module.exports = __webpack_public_path__ + "static/media/tyre-red-four5.caea1837.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tyre-red-four5.png
// module id = 347
// module chunks = 0